const style = document.createElement("style");
style.innerHTML = `
  .dividend-info-container {
    display: flex; 
    transition: transform 300ms ease-in-out; 
  }
  .carousel-button-container {
    display: flex; 
    justify-content: center; 
    align-items: center; 
    margin-top: 14px;
  }
  @media (min-width: 768px) {
    .dividend-info-container {
      display: grid;
      gap: 1rem;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .carousel-button-container {
      display: none;
    }
  }
`;
document.head.appendChild(style);

// url參數
let scriptId = document.getElementById("fundDividendScript");

let mfxId =
  scriptId && scriptId.attributes["mfx-id"]
    ? scriptId && scriptId.attributes["mfx-id"].value
    : "ALGW";

// 數字格式化
function NumFormatter(num, decimal) {
  this.value =
    num !== null && num !== undefined
      ? num.toLocaleString(undefined, {
          minimumFractionDigits: decimal,
          maximumFractionDigits: decimal,
        })
      : "--";

  this.addPercent = function () {
    this.value =
      num !== null && num !== undefined ? `${this.value}%` : this.value;
    return this;
  };

  this.addPrefix = function () {
    if (num > 0) this.value = `+${this.value}`;
    if (num < 0) this.value = `${this.value}`;
    return this;
  };
}

function numHandler(num, decimal = 2) {
  return new NumFormatter(num, decimal);
}

function formatPercent(num, decimal) {
  return numHandler(num, decimal).addPercent().value; // 12.55%
}

function formatReturnPercent(num, decimal) {
  return numHandler(num, decimal).addPercent().addPrefix().value; //+12.55%
}

function numTextColor(num) {
  if (num !== null && num !== undefined) {
    return num > 0
      ? "text-red-500"
      : num < 0
      ? "text-green-500"
      : "text-gray-500";
  } else {
    return "text-gray-800";
  }
}

// 渲染數據區塊
function renderDataBlock(title, yieldValue, profitValue, roiValue) {
  return `
    <div style="width: 100%; flex-shrink: 0; cursor: pointer; background-color: #F5F5F5; border-radius: 4px; margin-top: 16px;">
      <div style="padding: 16px;">
        <div style="font-weight: 500; font-size:18px; color: #333333;">${title}</div>
        <div style="display: flex; justify-content: space-between; align-items: center; font-size:16px; color: #666666; border-bottom: 1px solid #E5E5E5; padding-bottom: 8px;">
          <div>配息率</div>
          <div>${yieldValue ? formatPercent(yieldValue * 100) : '--'}</div>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; font-size:16px; color: #666666; padding-top: 8px;">
          <div>報酬率(含息)</div>
          <div class="${profitValue ? numTextColor(profitValue) : ''}">${profitValue ? formatReturnPercent(
    profitValue * 100
  ) : '--'}</div>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; font-size:16px; color: #666666;">
          <div>報酬率(不含息)</div>
          <div class="${roiValue ? numTextColor(roiValue) : '--'}">${roiValue ? formatReturnPercent(
    roiValue * 100
  ) : '--'}</div>
        </div>
      </div>
    </div>
  `;
}

// 處理滑動功能
let carouselIndex = 0;
function updateSliderPosition() {
  const slider = document.getElementById("slider"); // 獲取 slider
  const items = slider ? slider.children : 0; // 取得子項目數量
  // 根據 carouselIndex 的位置來改變背景顏色
  const prevButton = document.getElementById("prevButton");
  const nextButton = document.getElementById("nextButton");
  const prevArrow = document.getElementById("prevArrow");
  const nextArrow = document.getElementById("nextArrow");

  if (carouselIndex < items.length - 1) {
    carouselIndex++; // 移到下一頁
    prevButton.style.background = "#EBEBEB";
    prevArrow.style.color = "#666666";
    nextButton.style.background = "#FF9664";
    nextArrow.style.color = "#CCCCCC";
  } else {
    carouselIndex--;
    prevButton.style.background = "#FF9664";
    prevArrow.style.color = "#CCCCCC";
    nextButton.style.background = "#EBEBEB";
    nextArrow.style.color = "#666666";
  }

  const percentage = -carouselIndex * 100; // 計算 translateX 百分比
  slider.style.transform = `translateX(${percentage}%)`; // 動態更新 transform
}

// 處理手機手勢滑動
let touchStartX = 0;
let touchEndX = 0;

function handleTouchStart(e) {
  touchStartX = e.changedTouches[0].screenX;
}

function handleTouchEnd(e) {
  touchEndX = e.changedTouches[0].screenX;
  if (Math.abs(touchStartX - touchEndX) > 50) {
    updateSliderPosition();
  }
}

function initializeCarousel() {
  const prevArrow = document.getElementById('prevArrow');
  const nextArrow = document.getElementById('nextArrow');
  const prevButton = document.getElementById('prevButton');
  const nextButton = document.getElementById('nextButton');

  const buttons = [prevArrow, nextArrow, prevButton, nextButton];
  buttons.forEach((button) => {
    button.addEventListener('click', () => updateSliderPosition());
  })
}

function getCurrentDate() {
  let url = `https://${window.location.host}/next/api/funds/detail/${mfxId}/dividend-history?page=1&size=10`;
  fetch(url)
    .then((response) => {
      // 檢查回應是否成功
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json(); // 將回應轉換為 JSON 格式
    })
    .then((data) => {
      const updateDate = document.getElementById("dividend-latest-date")
      if (data.items.length) {
        const latestDate = data.items[0].date
        updateDate.textContent =  `${latestDate} 更新`
      } else {
        updateDate.textContent =  `-- 更新`
      }
    })
}

function loadScript() {
  const targetElement = document.getElementById("fundDividendScript");

  let url = `https://${window.location.host}/next/api/funds/detail/${mfxId}/dividend`;
  fetch(url)
    .then((response) => {
      // 檢查回應是否成功
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json(); // 將回應轉換為 JSON 格式
    })
    .then((data) => {
      //建立基本資料區域
      const dividendInfo = document.createElement("div");

      //渲染基本資料
      dividendInfo.innerHTML = `
        <div>
            <div style="color: #333333; font-weight: 500; font-size: 18px; line-height: 1.75rem; margin-bottom: 0.75rem;">
                配息績效統計
              <span id="dividend-latest-date" style="font-size: 14px; color: #999999"></span>
            </div>
            <div style="font-size: 14px;">
                <div style="color: #666666">配息頻率：<span style="color: #333333; font-weight: 500;">${
                  data.divFrequency || '--'
                }</span></div>
                <div style="color: #666666">基金首次配息日：<span style="color: #666666">${
                  data.firstDivDate || '--'
                }</span></div>
            </div>

            <div style="overflow: hidden; width: 100%; margin: auto;"> 
              <div class="dividend-info-container" id="slider" style="transform: translateX(0%)">
                ${renderDataBlock(
                  "近一年累計",
                  data.accumulateDivYield,
                  data.accumulateDivProfit,
                  data.accumulateRoi
                )}
                ${renderDataBlock(
                  "今年累計",
                  data.thisYearDivYield,
                  data.thisYearDivProfit,
                  data.thisYearRoi
                )}
              </div>
            </div>

            <div class="carousel-button-container">
              <div id="prevArrow" style="width: 12px; height:12px; color: #CCCCCC; margin-right: auto; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M34.5 239L228.9 44.7c9.4-9.4 24.6-9.4 33.9 0l22.7 22.7c9.4 9.4 9.4 24.5 0 33.9L131.5 256l154 154.8c9.3 9.4 9.3 24.5 0 33.9l-22.7 22.7c-9.4 9.4-24.6 9.4-33.9 0L34.5 273c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
              </div>
              <button id="prevButton" style="width: 8px; height: 8px; background: #FF9664; border-radius: 50%; flex-shrink: 0; border: none; cursor: pointer; padding: 0; margin-right: 8px;"></button>
              <button id="nextButton" style="width: 8px; height: 8px; background: #EBEBEB; border-radius: 50%; flex-shrink: 0; border: none; cursor: pointer; padding: 0;"></button>
              <div id="nextArrow" style="width: 12px; height:12px; color: #666666; margin-left: auto; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.5 273L91.1 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.7-22.7c-9.4-9.4-9.4-24.5 0-33.9L188.5 256 34.5 101.3c-9.3-9.4-9.3-24.5 0-33.9l22.7-22.7c9.4-9.4 24.6-9.4 33.9 0L285.5 239c9.4 9.4 9.4 24.6 0 33.9z"/></svg>
              </div>
            </div>
        </div>
    `;
      
      targetElement.innerHTML = '';
      targetElement.appendChild(dividendInfo);
      initializeCarousel();
      getCurrentDate();
    })
    .catch((error) => {
      // 捕獲並處理錯誤
      console.error("發生錯誤:", error);
    });
}

loadScript();

// 處理視窗大小變化時，畫面顯示位置
const handleResize = () => {
  if (window.innerWidth > 768) {
    const slider = document.getElementById("slider");
    slider.style.transform = `translateX(0%)`;
  }
};

window.addEventListener("resize", handleResize);
window.addEventListener("touchstart", handleTouchStart);
window.addEventListener("touchend", handleTouchEnd);

window.addEventListener("beforeunload", () => {
  window.removeEventListener("resize", handleResize);
  window.removeEventListener("touchstart", handleTouchStart);
  window.removeEventListener("touchend", handleTouchEnd);
});
